// #region CONSTANTES
var ICON_BY_EXTENSIONS = {
  "file-audio": [".mp3", ".wma"],
  "file-csv": [".csv"],
  "file-excel": [".xls", ".xlsx", ".ods"],
  "file-image": [".bmp", ".gif", ".jpg", ".jpeg", ".png", ".svg"],
  "file-pdf": [".pdf"],
  "file-powerpoint": [".ppt"],
  "file-video": [".avi", ".mp4", ".mpg", "mpeg", ".wmp"],
  "file-word": [".doc", ".docx", ".odt", ".rtf", ".txt"]
}; // #endregion
// #region CLASS

/**
 * Utilitaire contenant des fonctions statiques pour les icônes
 * @category Utils
 * @hideconstructor
 */

var IconUtils = /*#__PURE__*/function () {
  function IconUtils() {}

  /**
   * Récupération d'une icône FontAwesome en fonction de l'extension d'un fichier
   * @param {string} fileExtension Extension du fichier (avec le point)
   * @returns {string} L'icône FontAwesome correspondant à l'extension du fichier
   */
  IconUtils.getFileIcon = function getFileIcon(fileExtension) {
    // Si le fichier a une extension, regarde si elle est dans le tableau extension, et retourne la clef correspondante
    if (fileExtension) {
      var fileExt = fileExtension.toLowerCase();
      var keys = Array.from(Object.keys(ICON_BY_EXTENSIONS));

      for (var i = 0; i < keys.length; i++) {
        if (ICON_BY_EXTENSIONS[keys[i]].includes(fileExt)) {
          return keys[i];
        }
      }
    } // Valeur par défaut si l'extension n'est pas trouvée


    return "file";
  };

  return IconUtils;
}(); // #endregion


export var getFileIcon = IconUtils.getFileIcon;